import React from 'react';
import PropTypes from 'prop-types';

const formatTime = (date) =>
  date.toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' });
const formatDate = (date, showYear = true) =>
  date.toLocaleDateString('sv-SE', { 
    day: 'numeric', 
    month: 'long',
    ...(showYear && {year: 'numeric'}),
    });

const EventDetails = ({ startDate, endDate, location }) => {
  const newStartDate = new Date(startDate);
  const newEndDate = new Date(endDate);
  const startTime = formatTime(newStartDate);
  const endTime = formatTime(newEndDate);

  const isSameYear = newStartDate.getFullYear() === newEndDate.getFullYear();
  const startDateFormatted = formatDate(newStartDate, !isSameYear);
  const endDateFormatted = formatDate(newEndDate);

  const isSameDate = newStartDate.toDateString() === newEndDate.toDateString();

  const renderDate = () => {
    if (isSameDate) {
      return `${startDateFormatted} ${newStartDate.getFullYear()}`;
    }
    return `${startDateFormatted}–${endDateFormatted}`;
  };

  return (
    <div className="event-details">
      <div className="event-details__info-container">
        <div
          className={`event-details__date ${isSameDate ? 'show-on-mobile' : ''}`}>
          <span className="event-details__subtext">Datum:</span>{renderDate()}
        </div>
      </div>
      {isSameDate && (
        <div className="event-details__info-container">
          <div className="event-details__time">
            <span className="event-details__subtext">Tid:</span>{' '}
            {`${startTime}–${endTime}`}
          </div>
        </div>
      )}
      {location && (
        <div className="event-details__info-container">
          <div className="event-details__location">
            <span className="event-details__subtext">Plats:</span>
            <div>{location}</div>
          </div>
        </div>
      )}
    </div>
  );
};

EventDetails.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  location: PropTypes.string,
};

export default EventDetails;
